
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalInputSingleChoice from '@/components/templates/study/ModalInputSingleChoice.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 解答入力モーダル(択一式)
 */
@Component({
  components: {
    ModalInputSingleChoice,
  },
})
export default class ModalCorrectSingleChoice extends Vue {
  /** モーダル要素 */
  @Ref()
  modalInputSingleChoice!: ModalInputSingleChoice

  /** 入力完了後に実行する処理 */
  private afterFunction?: StudyModel.AfterInputSingleChoiceFunction

  /**
   * モーダルの表示処理
   *
   * @param question 設問情報
   * @param afterFunction 入力完了後の処理
   */
  public showModal(question: StudyModel.Question, afterFunction: StudyModel.AfterInputSingleChoiceFunction): void {
    // ローディング開始
    this.$loading.start()

    // 入力後処理の保存
    this.afterFunction = afterFunction

    // 設問情報取得
    const questionContent = question.contents[0] as StudyModel.ContentSingleChoice

    // モーダル表示
    this.modalInputSingleChoice.show(question.managementLabel, questionContent.optionValues, question.inputValues[0])

    // ローディング終了
    this.$loading.complete()
  }

  /**
   * 入力値確定時の処理
   *
   * @param inputValue 入力値
   */
  private submitInput(inputValue: string): void {
    // undefinedブロックしているが、実際には必ず実行される
    if (!this.afterFunction) {
      return
    }
    this.afterFunction(inputValue)
  }
}
